import { call, put, takeEvery } from "redux-saga/effects";

import { PaginateQuery, ResponseGenerator } from "../../interfaces";
import {
  ADD_CITY,
  AddCityAction,
  DELETE_CITY,
  DeleteCityAction,
  GET_CITY,
  GET_CITIES,
  GET_CITY_SELECT_LIST,
  GetCityAction,
  GetCitySelectListAction,
  GetCitiesAction,
  UPDATE_CITY,
  UpdateCityAction,
} from "./actionTypes";
import {
  addCityError,
  addCitySuccess,
  deleteCityError,
  deleteCitySuccess,
  getCityError,
  getCitySelectListError,
  getCitySelectListSuccess,
  getCitySuccess,
  getCitiesError,
  getCitiesSuccess,
  updateCityError,
  updateCitySuccess,
} from "./actions";
import {
  addCity,
  deleteCity,
  getCity,
  getCitySelectList,
  getCities,
  updateCity,
} from "../../helpers/backend_helper";

function* getCitiesSaga({ payload: { request, history } }: GetCitiesAction) {
  try {
    const response: ResponseGenerator = yield call(
      getCities,
      request as PaginateQuery
    );
    yield put(getCitiesSuccess(response.data));
  } catch (error) {
    yield put(getCitiesError(error));
  }
}

function* getCitySaga({ payload: { id, history } }: GetCityAction) {
  try {
    const response: ResponseGenerator = yield call(getCity, id);
    yield put(getCitySuccess(response.data));
  } catch (error) {
    yield put(getCityError(error));
  }
}

function* getCitySelectListSaga({
  payload: { governorateId, history },
}: GetCitySelectListAction) {
  try {
    const response: ResponseGenerator = yield call(
      getCitySelectList,
      governorateId
    );
    yield put(getCitySelectListSuccess(response.data));
  } catch (error) {
    yield put(getCitySelectListError(error));
  }
}

function* addCitySaga({ payload: { request, history } }: AddCityAction) {
  try {
    yield call(addCity, request);
    yield put(addCitySuccess());
  } catch (error) {
    yield put(addCityError(error));
  }
}

function* updateCitySaga({
  payload: { id, request, history },
}: UpdateCityAction) {
  try {
    yield call(updateCity, id, request);
    yield put(updateCitySuccess());
  } catch (error) {
    yield put(updateCityError(error));
  }
}

function* deleteCitySaga({ payload: { id, history } }: DeleteCityAction) {
  try {
    yield call(deleteCity, id);
    yield put(deleteCitySuccess());
  } catch (error) {
    yield put(deleteCityError(error));
  }
}

function* CitySaga() {
  yield takeEvery(GET_CITIES, getCitiesSaga);
  yield takeEvery(GET_CITY, getCitySaga);
  yield takeEvery(GET_CITY_SELECT_LIST, getCitySelectListSaga);
  yield takeEvery(ADD_CITY, addCitySaga);
  yield takeEvery(UPDATE_CITY, updateCitySaga);
  yield takeEvery(DELETE_CITY, deleteCitySaga);
}

export default CitySaga;
